const TopicOverview = () =>
  import(
    /* webpackChunkName: "TopicViews" */ '../views/topics/TopicOverview.vue'
    );
const TopicDetails = () =>
  import(
    /* webpackChunkName: "TopicViews" */ '../views/topics/TopicDetails.vue'
    );
const TopicDetailsTickets = () =>
  import(
    /* webpackChunkName: "TopicViews" */ '../views/topics/TopicDetailsTickets.vue'
    );
const TopicDetailsExperts = () =>
  import(
    /* webpackChunkName: "TopicViews" */ '../views/topics/TopicDetailsExperts.vue'
    );

export const routeTopics = [
  {
    path: 'topic',
    name: 'TopicOverview',
    component: TopicOverview,
    meta: {
      title: 'Topics'
    }
  },
  {
    path: 'topic/:id',
    name: 'TopicDetails',
    redirect: 'topic/:id/ticket',
    component: TopicDetails,
    children: [
      {
        path: 'ticket',
        name: 'TopicTickets',
        component: TopicDetailsTickets,
        meta: {
          title: 'Topic - Ideas'
        }
      },
      {
        path: 'expert',
        name: 'TopicExperts',
        component: TopicDetailsExperts,
        meta: {
          title: 'Topic - Experts'
        }
      }
    ]
  }
];
